/**
 * GENERATED by scripts/generate-board-steps.ts from the committed docs/living/planner-magic-canvas/Main.dc.html — DO NOT EDIT.
 * Regenerate with `npm run board:generate`; `npm run check:board-parity` fails when this file and the board disagree.
 */

import { SAGE, WARM } from "../brand";

export const BOARD_STEPS = [
  {
    "key": "you",
    "crumb": "Personal details",
    "title": "Personal details",
    "why": "Your name as it is on your ID, how to reach you, and the details forms ask for."
  },
  {
    "key": "kids",
    "crumb": "Children and dependants",
    "title": "Children and Dependants",
    "why": "Who depends on you, and whether anyone still needs looking after. This answer decides which of the later questions you are asked at all.",
    "groups": [
      {
        "cols": 3,
        "tiles": [
          {
            "id": "child",
            "label": "Children",
            "full": "Child",
            "mark": "CHILD",
            "color": "#E08A2E"
          },
          {
            "id": "dep",
            "label": "Dependants",
            "full": "Dependant",
            "mark": "CARE",
            "color": "#7A6BA8"
          }
        ],
        "none": {
          "label": "Nobody depends on me",
          "prune": 6
        }
      }
    ],
    "rowsLead": "Your children.",
    "rowsNote": "",
    "cols": "96px 253px 150px 147px 254px 144px 216px",
    "headers": [
      {
        "label": "Who"
      },
      {
        "label": "Name"
      },
      {
        "label": "Date of birth"
      },
      {
        "label": "How they are related"
      },
      {
        "label": "Guardian and a backup",
        "strong": true
      },
      {
        "label": "Guardian named in will"
      }
    ],
    "cells": [
      {
        "kind": "joint",
        "k": "who",
        "title": "Who is this?",
        "word": "Name them",
        "undo": "Nobody named"
      },
      {
        "kind": "date",
        "k": "dob",
        "emptyThen": [
          {
            "kind": "picker",
            "k": "minor",
            "label": "Under 18?",
            "ph": "Choose…",
            "opts": [
              "No",
              "Yes"
            ]
          }
        ]
      },
      {
        "kind": "picker",
        "k": "crel",
        "ph": "Choose…",
        "opts": [
          "My son",
          "My daughter",
          "My stepchild"
        ]
      },
      {
        "kind": "joint",
        "k": "guard",
        "title": "Who would be their guardian?",
        "word": "Name a guardian",
        "undo": "No guardian named"
      },
      {
        "kind": "picker",
        "k": "inwill",
        "ph": "Choose…",
        "opts": [
          "Yes",
          "No",
          "Not sure"
        ]
      }
    ],
    "second": {
      "tiles": [
        "dep"
      ],
      "rowsLead": "",
      "rowsNote": "",
      "cols": "96px 280px 150px 200px 280px 216px",
      "headers": [
        {
          "label": "Who"
        },
        {
          "label": "Name"
        },
        {
          "label": "Date of birth"
        },
        {
          "label": "How they are related"
        },
        {
          "label": "Who looks after them?",
          "strong": true
        }
      ],
      "cells": [
        {
          "kind": "joint",
          "k": "dwho",
          "title": "Who is this?",
          "word": "Name them",
          "undo": "Nobody named"
        },
        {
          "kind": "date",
          "k": "ddob"
        },
        {
          "kind": "picker",
          "k": "drel",
          "ph": "Choose…",
          "opts": [
            "My adult child",
            "My grandchild",
            "I’m their guardian",
            "My parent",
            "My brother or sister",
            "Other — type it"
          ]
        },
        {
          "kind": "joint",
          "k": "dguard",
          "title": "Who looks after them?",
          "word": "Name them",
          "undo": "Nobody named"
        }
      ]
    },
    "pickNotes": {
      "inwill": {
        "No": "Naming someone here does not appoint them — only your will does that. Until it says so, a court decides who raises your children, and it will not see this plan. Getting the guardian into your will goes on the list on your plan’s home, ahead of everything else in this chapter.",
        "Not sure": "Worth checking, and it is one line in the will. Until you know, your executor has to assume a court will decide.",
        "Yes": "You’ve said your will names them. If that is right, your executor makes one phone call on the first day instead of an application to a court — worth checking the will says exactly that."
      },
      "crel": {
        "My stepchild": "Recording a stepchild here says nothing about your will or what you are leaving them. It only means they are not added automatically to the government forms that ask for children — because whether a stepchild qualifies depends on whether you were maintaining them, which is a judgement your executor makes with the facts in front of them, not one this product should make for you."
      }
    },
    "noteFor": {
      "child": "Use the name on their documents rather than the one you call them by. Your executor reads this list beside your will and has to work out who is who — “Kate” against “Katherine Anne” is where that stops. For a child under 18 the person named here is who your will would appoint as guardian; naming them here is not the appointment itself, but it is the answer your executor and your lawyer both need.",
      "dep": "Anyone who relies on you and would need someone to step in — a parent you care for, a grandchild you are raising, an adult child who cannot manage alone. Name who that person would be."
    },
    "nextNote": ""
  },
  {
    "key": "daily",
    "crumb": "Children’s daily needs",
    "title": "Their Day-to-Day",
    "why": "What whoever steps in that first night needs to know about each child or dependant still in your care.",
    "autoPick": true,
    "groups": [
      {
        "cols": 3,
        "tiles": [
          {
            "id": "k1",
            "label": "[Your first child]",
            "sub": "named on the screen before",
            "mark": "CHILD",
            "color": "#E08A2E"
          },
          {
            "id": "k2",
            "label": "[Your second child]",
            "sub": "named on the screen before",
            "mark": "CHILD",
            "color": "#E08A2E"
          },
          {
            "id": "d1",
            "label": "[Adult in your care]",
            "sub": "named on the screen before",
            "mark": "CARE",
            "color": "#7A6BA8"
          }
        ]
      }
    ],
    "noDup": [
      "k1",
      "k2",
      "d1"
    ],
    "rowsLead": "",
    "rowsNote": "",
    "cols": "152px 151px minmax(196px, 1fr) 151px 204px minmax(160px, 1fr) 118px 120px",
    "headers": [
      {
        "label": "Name"
      },
      {
        "label": "Their doctor"
      },
      {
        "label": "Health",
        "sub": "allergies, medications, conditions"
      },
      {
        "label": "School"
      },
      {
        "label": "Grade"
      },
      {
        "label": "Their day"
      },
      {
        "label": "Is faith important?"
      }
    ],
    "cells": [
      {
        "kind": "joint",
        "k": "doc",
        "title": "Who is their doctor?",
        "word": "Name them",
        "undo": "No doctor named"
      },
      {
        "kind": "text",
        "k": "health",
        "long": true,
        "ph": "e.g. peanut allergy",
        "bigTitle": "Allergies, medications and conditions",
        "bigHint": "What a caregiver needs to know tonight — and what they must never give them.",
        "bigPh": "e.g. Severe peanut allergy — an EpiPen is in the kitchen drawer and one in their backpack. Takes their ADHD medication each morning with breakfast. Mild asthma; the inhaler is in the bathroom cabinet.",
        "sample": "Severe peanut allergy — an EpiPen in the kitchen drawer…"
      },
      {
        "kind": "joint",
        "k": "school",
        "title": "Which school?",
        "word": "School name",
        "undo": "Not in school",
        "org": true
      },
      {
        "kind": "picker",
        "k": "grade",
        "ph": "Choose…",
        "opts": [
          "Not in school yet",
          "JK or SK",
          "Grades 1 to 8",
          "Grades 9 to 12",
          "College or university"
        ]
      },
      {
        "kind": "text",
        "k": "day",
        "long": true,
        "ph": "e.g. bus at 8:10",
        "bigTitle": "Their day",
        "bigHint": "The routine that keeps them steady, and anything they need that other children do not.",
        "bigPh": "e.g. School bus at 8:10 from the corner. Swimming Tuesdays and Thursdays at the Y. Needs the hall light on at night. The school calls their aide first — that is in their plan.",
        "sample": "School bus at 8:10 from the corner…"
      },
      {
        "kind": "seg",
        "k": "faith",
        "opts": [
          "Yes",
          "No"
        ],
        "then": {
          "Yes": [
            {
              "kind": "text",
              "label": "Which faith, and what it means day to day",
              "ph": "e.g. Catholic — Mass on Sundays",
              "w": "420px",
              "hint": "so whoever is caring for them can keep it the same"
            }
          ]
        }
      }
    ],
    "noteFor": {
      "d1": "For an adult who depends on you, \"School\" and \"Grade\" can be left — their day and their doctor are what the person stepping in needs."
    },
    "nextNote": "Each of them gets a one-page care sheet for whoever steps in — Save or print, on your plan’s home."
  },
  {
    "key": "spouse",
    "crumb": "Marital status",
    "title": "Marital Status",
    "why": "Marriage and separation change who inherits and what a court will accept. It reshapes more of what follows than any other answer here.",
    "groups": [
      {
        "cols": 3,
        "tiles": [
          {
            "id": "married",
            "label": "Married",
            "mark": "M",
            "color": "#B04E72"
          },
          {
            "id": "cl",
            "label": "Common-law",
            "mark": "CL",
            "color": "#7A6BA8"
          },
          {
            "id": "sep",
            "label": "Separated or divorced",
            "mark": "S/D",
            "color": "#5B7596"
          }
        ],
        "none": {
          "label": "No spouse or partner",
          "prune": 4
        }
      }
    ],
    "rowsLead": "",
    "rowsNote": "more than one can be true — you might be divorced from one person and married to another, and your executor needs both",
    "cols": "174px 280px 140px 140px 280px 216px",
    "headers": [
      {
        "label": "Your situation"
      },
      {
        "label": "Name"
      },
      {
        "label": "Their date of birth"
      },
      {
        "label": "Since when"
      },
      {
        "label": "Children",
        "sub": "from this relationship"
      }
    ],
    "cells": [
      {
        "kind": "joint",
        "k": "who",
        "title": "Who is your spouse or partner?",
        "word": "Name them",
        "undo": "Nobody named"
      },
      {
        "kind": "date",
        "k": "dob"
      },
      {
        "kind": "date",
        "k": "since"
      },
      {
        "kind": "joint",
        "k": "kidsfrom",
        "title": "Which of your children are from this relationship?",
        "word": "Pick children",
        "undo": "None from this one",
        "fromPlan": true
      }
    ],
    "second": {
      "tiles": [
        "sep"
      ],
      "cols": "174px 203px 140px 140px 185px 202px 216px",
      "headers": [
        {
          "label": "Your situation"
        },
        {
          "label": "Name"
        },
        {
          "label": "Their date of birth"
        },
        {
          "label": "When you separated"
        },
        {
          "label": "Ongoing support payments?"
        },
        {
          "label": "Children",
          "sub": "from this relationship"
        }
      ],
      "cells": [
        {
          "kind": "joint",
          "k": "who",
          "title": "Who is your former spouse or partner?",
          "word": "Name them",
          "undo": "Nobody named"
        },
        {
          "kind": "date",
          "k": "dob"
        },
        {
          "kind": "date",
          "k": "since"
        },
        {
          "kind": "picker",
          "k": "support",
          "ph": "Choose…",
          "opts": [
            "No",
            "I pay it",
            "I receive it",
            "I pay and I receive",
            "Not sure"
          ]
        },
        {
          "kind": "joint",
          "k": "kidsfrom",
          "title": "Which of your children are from this relationship?",
          "word": "Pick children",
          "undo": "None from this one",
          "fromPlan": true
        }
      ]
    },
    "pickNotes": {
      "support": {
        "I pay it": "Added for you: a support payment line in your monthly bills (chapter four), and the order or agreement in your documents (chapter five). Nothing to answer twice.",
        "I receive it": "Added for you: a support received line in your income (chapter four), and the order or agreement in your documents (chapter five). Support you receive usually does not carry on — what your executor needs to know is who was paying it, and whether anything was still owed to you.",
        "I pay and I receive": "Added for you: a payment line in your monthly bills AND a received line in your income (chapter four), plus the order or agreement in your documents (chapter five). Money going out and money coming in are two different tasks for your executor.",
        "Not sure": "Worth checking. An obligation that survives you binds your estate, and an executor who learns of it late has already paid other people first."
      }
    },
    "noteFor": {
      "cl": "Common-law is proved, not assumed — the date you began living together is what a survivor pension asks for, and nobody else can supply it."
    },
    "nextNote": ""
  },
  {
    "key": "pets",
    "crumb": "Pets",
    "title": "Pets or Other Animals",
    "why": "An animal needs someone the same day. Nothing else in this plan moves that fast.",
    "groups": [
      {
        "cols": 3,
        "tiles": [
          {
            "id": "pet",
            "label": "A pet, or other animals",
            "sub": "one row each — a single pet or a whole herd",
            "mark": "PET",
            "color": "#A3651F"
          },
          {
            "id": "vet",
            "label": "Your vet",
            "sub": "the practice name is what an executor phones",
            "mark": "VET",
            "color": SAGE[600]
          }
        ],
        "none": {
          "label": "No animals",
          "prune": 3
        }
      }
    ],
    "rowsLead": "What you look after, and who would take them.",
    "rowsNote": "one row for a single animal, one row for a whole herd — say how many rather than naming each",
    "cols": "142px 230px minmax(224px, 1fr) 280px 216px",
    "headers": [
      {
        "label": "What"
      },
      {
        "label": "What kind"
      },
      {
        "label": "Name, or how many"
      },
      {
        "label": "Who would take them?"
      }
    ],
    "second": {
      "tiles": [
        "vet"
      ],
      "cols": "142px 280px 216px",
      "headers": [
        {
          "label": "What"
        },
        {
          "label": "The practice"
        }
      ],
      "cells": [
        {
          "kind": "joint",
          "k": "call",
          "org": true,
          "title": "Who does your executor call?",
          "word": "Name the practice",
          "undo": "Nobody in particular"
        }
      ]
    },
    "cells": [
      {
        "kind": "picker",
        "k": "kind",
        "ph": "Choose…",
        "opts": [
          "Dog",
          "Cat",
          "Bird",
          "Horse",
          "Cattle or other livestock",
          "Small animal or reptile",
          "Other — type it"
        ]
      },
      {
        "kind": "text",
        "k": "name",
        "ph": "e.g. Bramble · four laying hens"
      },
      {
        "kind": "joint",
        "k": "who",
        "title": "Who would take them?",
        "word": "Name them",
        "undo": "Nobody named"
      }
    ],
    "noteFor": {
      "pet": "The one task with a deadline measured in hours rather than weeks. A name here is the difference between a phone call and a crisis.",
      "vet": "Your executor phones the practice, not a person — and the practice holds the history, the medication and often the microchip."
    },
    "nextNote": ""
  },
  {
    "key": "exec",
    "crumb": "Who your executor is",
    "title": "Your Executor",
    "why": "The person who will settle everything.",
    "groups": [
      {
        "cols": 3,
        "tiles": [
          {
            "id": "knows",
            "label": "Named, and they know",
            "mark": "EX",
            "color": "#003DA5"
          },
          {
            "id": "untold",
            "label": "Named, but I have not told them",
            "full": "Named, not told yet",
            "mark": "EX",
            "color": "#E08A2E"
          },
          {
            "id": "backup",
            "label": "Backup",
            "mark": "BK",
            "color": "#5B7596",
            "rowOnly": true,
            "numbered": true
          }
        ],
        "none": {
          "label": "I have not chosen one yet",
          "prune": 0,
          "delta": "Left open on purpose. Your will names the executor, not this plan — so until it does, this stays the one question waiting for you at the end."
        }
      }
    ],
    "rowsLead": "Who acts, and how you are connected.",
    "rowsNote": "more than one can be true",
    "cols": "280px 280px 233px 253px 216px",
    "headers": [
      {
        "label": "Their standing"
      },
      {
        "label": "Name"
      },
      {
        "label": "How they are related to you"
      },
      {
        "label": "Does your will name a backup executor?",
        "strong": true
      }
    ],
    "cells": [
      {
        "kind": "joint",
        "k": "who",
        "title": "Who is your executor?",
        "word": "Name them",
        "undo": "Nobody named"
      },
      {
        "kind": "picker",
        "k": "rel",
        "ph": "Choose…",
        "opts": [
          "My spouse or partner",
          "My daughter",
          "My son",
          "My brother or sister",
          "A friend",
          "My lawyer or accountant",
          "Other — type it"
        ]
      },
      {
        "kind": "picker",
        "k": "bk",
        "ph": "Choose…",
        "opts": [
          "Yes",
          "No",
          "Not sure"
        ],
        "firstOnly": true,
        "addsRow": "backup",
        "hidesRowOn": [
          "No",
          "Not sure"
        ]
      }
    ],
    "rules": {
      "backup": {
        "bk": false
      }
    },
    "pickNotes": {
      "bk": {
        "Yes": "Add them here, so they can open your plan if they’re needed. Their row is below — name them the same way.",
        "No": "Only the will can name one. Ask your lawyer to add a backup when you next update it. Until then, only your executor can open this plan. Added to the list on your plan’s home.",
        "Not sure": "Only the will can name one. Ask your lawyer to add a backup when you next update it. Until then, only your executor can open this plan. Added to the list on your plan’s home."
      }
    },
    "noStanding": {
      "ph": "Their standing"
    },
    "backupStanding": {
      "ph": "Have you told them?",
      "opts": [
        "and they know",
        "not told yet"
      ],
      "untoldNote": "Added to the list on your plan’s home: ask them. A backup who finds out on the day starts from behind, and it is a five-minute conversation rather than a project."
    },
    "execStanding": {
      "ph": "Their standing",
      "opts": [
        "Named, and they know",
        "Named, not told yet"
      ]
    },
    "noteFor": {
      "untold": "Added to the list on your plan’s home: tell them. Someone who finds out on the day starts from behind, and it is a five-minute conversation rather than a project."
    },
    "nextNote": "Nothing is sent yet. You’ll set what they see, and send the invite, on the Access screen."
  },
  {
    "key": "benef",
    "crumb": "Beneficiaries",
    "title": "Beneficiaries",
    "why": "Who they are, and one way to reach them.",
    "groups": [
      {
        "cols": 3,
        "tiles": [
          {
            "id": "family",
            "label": "Family",
            "sub": "a parent, a brother or sister, a grandchild, a niece or nephew",
            "mark": "FAM",
            "color": "#B04E72"
          },
          {
            "id": "friend",
            "label": "A friend, or someone not related",
            "sub": "one row each",
            "mark": "FRD",
            "color": "#3F7A75"
          },
          {
            "id": "charity",
            "label": "A charity or an organisation",
            "sub": "the exact legal name is what your executor needs",
            "mark": "CHY",
            "color": "#B8860B"
          },
          {
            "id": "other",
            "label": "Someone else",
            "sub": "not listed above",
            "full": "Who they are",
            "typed": true,
            "mark": "…",
            "color": WARM.taupe
          }
        ],
        "none": {
          "label": "No one",
          "prune": 0,
          "delta": "Noted. Your will decides who inherits and nothing here changes that — but your executor is now told there is nobody extra to go and find."
        }
      }
    ],
    "rowsLead": "Who they are, and how to reach them.",
    "rowsNote": "",
    "rules": {
      "charity": {
        "minor": false,
        "dob": false
      }
    },
    "cols": "162px 280px 232px 119px 160px 216px",
    "headers": [
      {
        "label": "Which kind"
      },
      {
        "label": "Name"
      },
      {
        "label": "How you know them"
      },
      {
        "label": "Under 18?"
      },
      {
        "label": "Date of birth",
        "sub": "only if under 18"
      }
    ],
    "cells": [
      {
        "kind": "joint",
        "k": "who",
        "title": "Who is this?",
        "word": "Name them",
        "undo": "Nobody named",
        "orgBy": {
          "charity": true
        }
      },
      {
        "kind": "picker",
        "k": "rel",
        "ph": "Choose…",
        "opts": [
          "My parent",
          "My brother or sister",
          "My grandchild",
          "My niece or nephew",
          "A friend",
          "A godchild",
          "A neighbour",
          "A colleague",
          "A charity or organisation",
          "Other — type it"
        ],
        "fromKid": "My child"
      },
      {
        "kind": "picker",
        "k": "minor",
        "ph": "Choose…",
        "opts": [
          "No",
          "Yes"
        ],
        "fromKid": "Yes"
      },
      {
        "kind": "date",
        "k": "dob",
        "onWhen": {
          "k": "minor",
          "vIn": [
            "Yes"
          ]
        },
        "fromKid": "[from chapter one]"
      }
    ],
    "pickNotes": {
      "minor": {
        "Yes": "Their share is held for them until they turn 18, and the probate application asks their age."
      }
    },
    "noteFor": {
      "family": "Use the name on their documents, not the one you call them by — your executor reads this list beside your will, and two people can look like one. Naming someone here does not decide what they get — your will does that. It means your executor can find them, which is the part that stalls without a phone number.",
      "friend": "A friend is the hardest person on this list for an executor to find — no shared surname, and no family to ask. A surname and a phone number is usually all it takes.",
      "charity": "Charities merge and rename more often than people expect, and a well-meant gift can reach the wrong organisation. The exact legal name is what makes it land.",
      "other": "Recorded so it is not lost. Nobody can act on a wish that stayed in your head."
    },
    "nextNote": ""
  },
  {
    "key": "mil",
    "crumb": "Military or RCMP service",
    "title": "Military or RCMP Service",
    "why": "Select where you have served, now or in the past.",
    "groups": [
      {
        "cols": 3,
        "tiles": [
          {
            "id": "caf",
            "label": "Canadian Armed Forces",
            "sub": "regular or reserve, now or in the past",
            "mark": "CAF",
            "color": "#003DA5"
          },
          {
            "id": "rcmp",
            "label": "The RCMP",
            "sub": "now or in the past",
            "mark": "RCMP",
            "color": "#8B1E3F"
          },
          {
            "id": "milother",
            "label": "Another country’s forces",
            "sub": "not listed above",
            "full": "Which country",
            "typed": true,
            "mark": "…",
            "color": WARM.taupe
          }
        ],
        "none": {
          "label": "I have not served",
          "prune": 1,
          "delta": "Noted. Your executor will not spend time checking for veterans’ benefits."
        }
      }
    ],
    "noDup": [
      "caf",
      "rcmp"
    ],
    "rowsLead": "Where you served.",
    "rowsNote": "your service papers are asked for in chapter five, with your other papers",
    "cols": "260px 94px 182px 126px",
    "headers": [
      {
        "label": "Service"
      },
      {
        "label": "Serving now?"
      },
      {
        "label": "A pension from this service?"
      }
    ],
    "cells": [
      {
        "kind": "seg",
        "k": "now",
        "opts": [
          "Yes",
          "No"
        ]
      },
      {
        "kind": "seg",
        "k": "pension",
        "opts": [
          "Yes",
          "No"
        ]
      }
    ],
    "pickNotes": {
      "pension": {
        "Yes": "Added for you: a pension row on your Income screen in chapter four, with the pension office already filled in. What it pays is asked there, once — and the part that carries on to a survivor is paid only if someone claims it."
      }
    },
    "noteFor": {
      "caf": "Veterans Affairs Canada and the Last Post Fund may help with funeral and burial costs and a military grave marker, and a spouse may have a survivor’s benefit to claim. None of it is paid automatically, and the funeral help is best asked for before the funeral is paid for — your executor now knows to ask.",
      "rcmp": "Veterans Affairs Canada serves RCMP members too, and the same funeral, burial and survivor benefits may apply. None of it is paid automatically — your executor now knows to ask.",
      "milother": "Many countries have a veterans’ office with its own funeral and survivor benefits. Your executor contacts that country’s office, with your service papers.",
      "now": "If you are serving, your unit or detachment is your executor’s first call. They have their own process, and usually assign someone to help your family."
    },
    "nextNote": ""
  },
  {
    "key": "ids",
    "crumb": "Government ID",
    "title": "Government ID",
    "why": "Select any of these you have.",
    "groups": [
      {
        "cols": 3,
        "tiles": [
          {
            "id": "sin",
            "label": "Social Insurance Number",
            "mark": "SIN",
            "color": "#8B1E3F"
          },
          {
            "id": "licence",
            "label": "Driver’s licence",
            "mark": "DL",
            "color": "#003DA5"
          },
          {
            "id": "passport",
            "label": "Passport",
            "mark": "PP",
            "color": "#3F7A75"
          },
          {
            "id": "health",
            "label": "Health card",
            "mark": "OHIP",
            "color": "#62744C"
          },
          {
            "id": "parking",
            "label": "Accessible parking permit",
            "mark": "APP",
            "color": "#2F7FB8"
          },
          {
            "id": "status",
            "label": "Status card",
            "sub": "First Nations status",
            "mark": "STAT",
            "color": "#A3651F"
          }
        ],
        "none": {
          "label": "None of these",
          "prune": 6
        }
      }
    ],
    "noDup": [
      "sin",
      "licence",
      "passport",
      "health",
      "parking",
      "status"
    ],
    "noteFor": {
      "status": "With status, and if you live on a reserve, your estate is usually handled by Indigenous Services Canada rather than the Ontario court — so that is the first call your executor makes."
    },
    "rowsLead": "Where each one is kept.",
    "rowsNote": "optional — a drawer or a wallet is enough for your executor to start looking in the right place",
    "cols": "262px 266px 126px",
    "headers": [
      {
        "label": "What you have"
      },
      {
        "label": "Where is it kept?"
      }
    ],
    "cells": [
      {
        "kind": "text",
        "k": "where",
        "long": true,
        "ph": "e.g. the blue folder · my wallet",
        "bigTitle": "Where is it kept?",
        "bigHint": "Your executor may never have been inside your home.",
        "bigPh": "e.g. In the blue accordion folder in the filing cabinet in the spare room, second drawer, at the back behind the tax returns.",
        "sample": "In the blue accordion folder in the filing cabinet…"
      }
    ],
    "nextNote": ""
  },
  {
    "key": "done",
    "crumb": "Checkpoint",
    "title": "That is chapter one.",
    "why": "Everything from here is shaped by what you just told us."
  }
];
